var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 31.1875C2.33333 26.2292 0.625 19.1667 0.625 10V0.9375H25.25L71.75 51.875C74.375 54.7917 76.125 57.25 77 59.25C77.875 61.25 78.5208 63.0833 78.9375 64.75C79.8542 68.0833 80.3125 72.1875 80.3125 77.0625V86H56.375L5.9375 31.1875H5.75ZM53.25 27.625C53.25 16.1667 55.0208 8.70833 58.5625 5.25C60.4375 3.41667 62.875 2.25 65.875 1.75C68.9167 1.20833 72.6042 0.9375 76.9375 0.9375H80.3125V10.8125C80.3125 19.6875 77.9792 25.625 73.3125 28.625C69.9792 30.7917 64.375 31.875 56.5 31.875H53.25V27.625ZM0.625 76.25C0.625 67.375 2.95833 61.4167 7.625 58.375C10.9583 56.25 16.5625 55.1875 24.4375 55.1875H27.6875V59.4375C27.6875 71.0208 25.9167 78.4583 22.375 81.75C19.9583 84 16.4375 85.3333 11.8125 85.75C9.47917 85.9167 6.875 86 4 86H0.625V76.25Z",
    fill: "#F955C8",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.fba86acdf9a65fc19b15c9780f017ff8.svg";
export { ForwardRef as ReactComponent };